export default __webpack_public_path__ + "static/media/why-we-here-img.62cdda0b.jpg";